import * as React from 'react';
import { Component } from 'react';
import { IDiseaseCategory } from '../../models/IDiseaseCategory';
import { DiseaseCategoryService } from '../../services/DiseaseCategoryService';
import { SimpleSelectComponent } from '../../controls/SimpleSelect';
import { IDropDownItem } from '../../models/IDropDownItem';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';

interface IProps {
    IsEditMode: boolean,
    DiseaseCategories: IDiseaseCategory[],
    AllDiseaseCategories: IDropDownItem[],
    OnRefreshRequired: () => void
}

interface IState {
    ShowAddCategories: boolean,
    DiseaseCategoryInputValue?: string,
    ShowAll: boolean,
    LoaderVisible: boolean,
    SelectedCategory?: IDropDownItem
}

export class DiseaseCategoriesComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAddCategories: false,
            ShowAll: this.props.IsEditMode,
            LoaderVisible: false
        }

        this.OnAddNewDiseaseCategory = this.OnAddNewDiseaseCategory.bind(this);
        this.OnDiseaseCategoryDelete = this.OnDiseaseCategoryDelete.bind(this);
        this.OnDiseaseCategoryDeleteSuccess = this.OnDiseaseCategoryDeleteSuccess.bind(this);
        this.OnDiseaseCategoryDeleteError = this.OnDiseaseCategoryDeleteError.bind(this);
        this.OnAbort = this.OnAbort.bind(this);
        this.OnDiseaseCategorySelected = this.OnDiseaseCategorySelected.bind(this);
        this.OnInputValueChange = this.OnInputValueChange.bind(this);
        this.OnAddDiseaseCategorySuccess = this.OnAddDiseaseCategorySuccess.bind(this);
        this.OnAddDiseaseCategoryError = this.OnAddDiseaseCategoryError.bind(this);
        this.OnSave = this.OnSave.bind(this);
        this.ShowMore = this.ShowMore.bind(this);
        this.ShowLess = this.ShowLess.bind(this);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <a onClick={this.OnAddNewDiseaseCategory}>Dodaj kategorię</a>
                    </div>
                );
        }
            if (this.state.ShowAddCategories && this.state.SelectedCategory !== undefined) {
                buttons = (
                    <div className="buttons">
                        <button className="std-secondary-btn" onClick={this.OnAbort}>Anuluj</button>
                        <button className="std-primary-btn" onClick={this.OnSave}>Zapisz</button>
                    </div>
                );
            }
            let categories: null | IDiseaseCategory[] = null;
            if (this.state.ShowAll) {
                categories = this.props.DiseaseCategories;
            } else {
                categories = this.props.DiseaseCategories.filter((i, index) => (index < 4));
            }
            let items = categories.map((category) => (
                <li key={category.Id}>
                    <span>{category.Name}</span>&nbsp;
                    {
                        this.props.IsEditMode ?
                            (
                                <div>
                                    <span className="delete-icon"  onClick={this.OnDiseaseCategoryDelete.bind(this, category.Name)} />
                                </div>
                            ) :
                            null
                    }
                </li>
            ));
            let showMoreElement: null | JSX.Element = null;
            if (this.props.DiseaseCategories.length > 4) {
                if (this.state.ShowAll) {
                    showMoreElement = (
                        <li key={0}>
                            <a onClick={this.ShowLess}>zobacz mniej</a>
                        </li>
                    );
                } else {
                    showMoreElement = (
                        <li key={0}>
                            <a onClick={this.ShowMore}>zobacz więcej</a>
                        </li>
                    );
                }
            }
            itemsElement = (
                <div className="input">
                    <ul className="diseases-list">
                        <LoaderComponent Visible={this.state.LoaderVisible} />
                        {items}
                        {
                            items.length === 0 ?
                                (<div className="info">
                                    <p>
                                        Z jakimi pacjentami pracujesz najczęściej?
                                    </p>
                                </div>) :
                                null
                        }
                        {showMoreElement}
                    </ul>
                    {
                        this.state.ShowAddCategories && 
                            <SimpleSelectComponent
                                Items={this.props.AllDiseaseCategories}
                                Placeholder="Wybierz kategorię"
                                OnItemSelected={this.OnDiseaseCategorySelected}
                                OnValueChange={this.OnInputValueChange} />
                    }
                    {buttons}
                </div>
            );
        return (
            <div className="form-row">
                <label>Schorzenia:</label>
                {itemsElement}
            </div>
        );
    }//end-of-render

    private OnAddNewDiseaseCategory(evt) {
        this.setState({
            ShowAddCategories: true
        });
    }

    private OnDiseaseCategoryDelete(name: string, evt) {
        this.setState({
            LoaderVisible: true
        });
        let service = new DiseaseCategoryService();
        service.RemoveDiseaseCategoryGroup(name, this.OnDiseaseCategoryDeleteSuccess, this.OnDiseaseCategoryDeleteError);
    }

    private OnDiseaseCategoryDeleteSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Usunięto kategorię schorzeń', DEFAULT_STATUS_TIMEOUT);
    }

    private OnDiseaseCategoryDeleteError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się usunąć kategorii schorzeń. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAbort(evt) {
        this.setState({
            ShowAddCategories: false
        });
    }

    private OnDiseaseCategorySelected(selectedItem: IDropDownItem) {
        //this.setState({
        //    ShowAddCategories: false,
        //    LoaderVisible: true
        //});
        //let service = new DiseaseCategoryService();
        //service.AddMyDiseaseCategoryGroup({
        //    DiseaseCategoryId: selectedItem.Id,
        //    DiseaseCategoryName: selectedItem.Value
        //}, this.OnAddDiseaseCategorySuccess, this.OnAddDiseaseCategoryError);
        this.setState({
            SelectedCategory: selectedItem
        });
    }

    private OnAddDiseaseCategorySuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Kategoria schorzeń dodana', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAddDiseaseCategoryError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się dodać kategorii schorzeń. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnInputValueChange(evt) {
        this.setState({
            DiseaseCategoryInputValue: evt.target.value
        });
    }

    private OnSave(evt) {
        if (this.state.SelectedCategory !== undefined) {
            this.setState({
                ShowAddCategories: false,
                LoaderVisible: true
            });
            let service = new DiseaseCategoryService();
            service.AddMyDiseaseCategoryGroup({
                DiseaseCategoryId: this.state.SelectedCategory.Id,
                DiseaseCategoryName: this.state.SelectedCategory.Value
            }, this.OnAddDiseaseCategorySuccess, this.OnAddDiseaseCategoryError);
        } else {
            if (this.state.DiseaseCategoryInputValue !== undefined && this.state.DiseaseCategoryInputValue !== '') {
                this.setState({
                    ShowAddCategories: false,
                    LoaderVisible: true
                });
                let service = new DiseaseCategoryService();
                service.AddMyDiseaseCategory(
                    { DiseaseCategoryName: this.state.DiseaseCategoryInputValue },
                    this.OnAddDiseaseCategorySuccess,
                    this.OnAddDiseaseCategoryError);
            }
        }
    }

    private ShowMore(evt) {
        this.setState({
            ShowAll: true
        });
    }

    private ShowLess(evt) {
        this.setState({
            ShowAll: false
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/DiseaseCategories.tsx